<template>
  <div>
    <div class="position-relative">
      <baniere @oga="nextDevi" />
    </div>
    <avantages id="yourID" />
    <ortherSupport />
    <strategie />
    <marcketing @oga="nextDevi" />
    <sondage />
    <realisations />
    <partenaires />

    <!-- <div id="devis">
      <formulaire />
    </div> -->

    <!-- <equipe /> -->
    <contact />
  </div>
</template>

<script>
import baniere from "@/views/myComponent/baniere";
import avantages from "@/views/myComponent/avantages";
import strategie from "@/views/myComponent/strategie";
import marcketing from "@/views/myComponent/marcketing";
import realisations from "@/views/myComponent/realisations";
// import equipe from "@/views/myComponent/equipe";
import sondage from "@/views/myComponent/sondage";
// import formulaire from "@/views/myComponent/formulaire";
import contact from "@/views/myComponent/contact";
import partenaires from "@/views/myComponent/partenaires";
import ortherSupport from "@/views/myComponent/ortherSupport";

export default {
  name: "home",
  components: {
    baniere,
    avantages,
    strategie,
    marcketing,
    realisations,
    // equipe,
    sondage,
    // formulaire,
    contact,
    partenaires,
    ortherSupport,
  },

  methods: {
    nextBloc(answer) {
      let element = document.getElementById("yourID");
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },

    nextDevi(answer) {
      let element = document.getElementById("devis");
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
  },

  metaInfo() {
    return {
      title:
      "Régie Publicitaire au Bénin | Vélo Publicitaire, Street Marketing et Activation de Marque",

      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Panneau Mobile accompagne les marques au Bénin grâce aux vélos publicitaires, tricycles publicitaires, moving boards, street marketing, distribution de flyers et activation de marque."
        },

        {
          vmid: "keywords",
          name: "keywords",
          content:
            "régie publicitaire bénin, vélo publicitaire bénin, tricycle publicitaire, moving board, street marketing bénin, activation de marque, publicité mobile cotonou"
        }
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Panneau Mobile",
            "url": "https://www.panneaumobile.co",
            "description": "Régie publicitaire spécialisée dans le marketing de proximité au Bénin",
            "areaServed": "Benin",
            "serviceType": [
              "Vélo publicitaire",
              "Street Marketing",
              "Activation de marque",
              "Moving Board",
              "Tricycle publicitaire",
              "Distribution de flyers"
            ]
          }
        }
      ]
    };
  }
};
</script>
<style></style>
